var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.title,
            width: "50%",
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "justify-content": "center" } },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.params,
                    rules: _vm.rules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "渠道配置：", prop: "channel" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.params.channel,
                            callback: function ($$v) {
                              _vm.$set(_vm.params, "channel", $$v)
                            },
                            expression: "params.channel",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("全部渠道"),
                          ]),
                          _c("el-radio", { attrs: { label: "2" } }, [
                            _vm._v("指定渠道"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.params.channel === "2"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "渠道选择：" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea" },
                            on: {
                              focus: function ($event) {
                                return _vm.handleClick()
                              },
                            },
                            model: {
                              value: _vm.params.appidFilterNames,
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "appidFilterNames", $$v)
                              },
                              expression: "params.appidFilterNames",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: "价格样式：", prop: "useType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.params.useType,
                            callback: function ($$v) {
                              _vm.$set(_vm.params, "useType", $$v)
                            },
                            expression: "params.useType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("原价样式"),
                          ]),
                          _c("el-radio", { attrs: { label: "2" } }, [
                            _vm._v("折扣价样式"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "原价：", prop: "former" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { maxlength: 99, placeholder: "请输入原价" },
                        model: {
                          value: _vm.params.former,
                          callback: function ($$v) {
                            _vm.$set(_vm.params, "former", $$v)
                          },
                          expression: "params.former",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.params.useType === "2"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "现价：", prop: "now" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: { maxlength: 99, placeholder: "请输入现价" },
                            model: {
                              value: _vm.params.now,
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "now", $$v)
                              },
                              expression: "params.now",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: "价格后缀：", prop: "suffix" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { maxlength: 99, placeholder: "请输入价格后缀" },
                        model: {
                          value: _vm.params.suffix,
                          callback: function ($$v) {
                            _vm.$set(_vm.params, "suffix", $$v)
                          },
                          expression: "params.suffix",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSave } },
                [_vm._v("保存")]
              ),
              _c("el-button", { on: { click: _vm.hide } }, [_vm._v("取消")]),
            ],
            1
          ),
        ]
      ),
      _c("channel-popups", {
        attrs: {
          isAppendToBody: false,
          modelIsAppendToBody: false,
          "app-id": _vm.params.appidFilterList,
          visible: _vm.showPopups,
        },
        on: {
          "update:visible": function ($event) {
            _vm.showPopups = $event
          },
          comfirm: _vm.handleConfirm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }